<template>
  <div class="container-fluid px-0">
    <div class="row content mx-0">
      <div class="col-1 px-0"></div>
      <div class="col-10 px-0">
        <div class="row mx-0">
          <div class="col-12 px-0 text-end my-3 machStatus-update-time">
            <span class="my-0" id="machStatus-update-time">更新時間:</span>
            <span class="my-0" for="machStatus-update-time">
              {{ nowTime }}
            </span>
          </div>
          <div class="col-12 px-0 text-start">
            <button class="machStatus-button mx-0" @click="detail = false">
              返回
            </button>
          </div>
          <div class="col-12 px-0">
            <div class="row mx-0">
              <div class="col-12 mt-3 px-0 mb-2">
                <div class="row mx-0">
                  <div
                    class="col-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 px-0"
                  >
                    <img
                      :src="machineImage"
                      class="mx-auto machStatus-main-image"
                      alt="Center image"
                    />
                  </div>
                  <div
                    class="col-12 col-md-12 col-lg-8 col-xl-9 col-xxl-9 px-0"
                  >
                    <div class="row mx-0 text-start machStatus-introduce">
                      <div class="col-12 col-xxl-7 px-0">
                        <div class="row mx-0">
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            製程:{{ siteName }}
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            產線:{{ operName }}
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            機號:{{ deviceName }}
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            型號:{{ deviceModel }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12 col-xxl-5 px-0 machStatus-status-bar machStatus-introduce-list"
                      >
                        狀態:
                        <div class="machStatus-status-color-bar">
                          <div class="d-flex justify-content-start">
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'R'
                                    ? 'var(--main-status-success-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              運轉
                            </div>
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'M'
                                    ? 'var(--main-status-maintain-color)'
                                    : machine_status === 'H'
                                    ? 'var(--main-status-stop-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              {{
                                machine_status === "M"
                                  ? "維修"
                                  : machine_status === "H"
                                  ? "關機"
                                  : "關機"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mx-0">
                      <div class="col-12 px-0 mb-2">
                        <div class="input-group machStatus-input-group">
                          <span
                            class="input-group-text machStatus-input-group-text"
                            >機台狀態</span
                          >
                          <input
                            type="text"
                            aria-label="First name"
                            class="form-control"
                            disabled
                            :value="'運轉時間：' + deviceRunTime"
                            style="min-width: 180px"
                          />
                          <input
                            type="text"
                            aria-label="Last name"
                            class="form-control"
                            disabled
                            :value="'待機時間：' + deviceQueueTime"
                            style="min-width: 180px"
                          />
                          <input
                            type="text"
                            aria-label="Last name"
                            class="form-control"
                            disabled
                            :value="'開機稼動率：' + deviceActivation + '%'"
                            style="min-width: 165px"
                          />
                          <input
                            type="text"
                            aria-label="Last name"
                            class="form-control"
                            disabled
                            :value="'日累計產量：' + deviceDayWeight + '(KG)'"
                            style="min-width: 215px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 px-0">
                    <div class="col-12 px-0">
                      <div class="stackBarTitle" style="padding-bottom: 28px">
                        焠火入料狀態 :
                      </div>
                      <div class="stackBarContent">
                        <stackBar
                          :stacksBarClass="stacksBarClass"
                          :stacksBarMaxValue="stacksBarMaxValue"
                          :stacksData="htInStackInformation"
                          :stacksSize="'normal'"
                        />
                      </div>
                    </div>
                    <div class="col-12 px-0">
                      <div class="stackBarTitle">出料狀態 :</div>
                      <div class="stackBarContent">
                        <stackBar
                          :stacksBarClass="stacksBarClass"
                          :stacksBarMaxValue="stacksBarMaxValue"
                          :stacksData="htOutStackInformation"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 my-3 px-0">
                <nav class="px-0">
                  <div
                    class="nav nav-tabs mes-tabs"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 0 }"
                      id="nav-instant-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-instant"
                      type="button"
                      role="tab"
                      aria-controls="nav-instant"
                      aria-selected="true"
                      @click="detailTabIndex = 0"
                    >
                      即時工單狀態
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 2 }"
                      id="nav-camera-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-camera"
                      type="button"
                      role="tab"
                      aria-controls="nav-camera"
                      aria-selected="false"
                      @click="detailTabIndex = 2"
                    >
                      機台影像
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 3 }"
                      id="nav-operate-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-operate"
                      type="button"
                      role="tab"
                      aria-controls="nav-operate"
                      aria-selected="false"
                      @click="detailTabIndex = 3"
                    >
                      運轉日誌
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 4 }"
                      id="nav-complete-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-complete"
                      type="button"
                      role="tab"
                      aria-controls="nav-complete"
                      aria-selected="false"
                      @click="detailTabIndex = 4"
                    >
                      當日完成工單
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 5 }"
                      id="nav-alarm-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-alarm"
                      type="button"
                      role="tab"
                      aria-controls="nav-alarm"
                      aria-selected="false"
                      @click="detailTabIndex = 5"
                    >
                      警報履歷
                    </button>
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 6 }"
                      id="nav-light-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-light"
                      type="button"
                      role="tab"
                      aria-controls="nav-light"
                      aria-selected="false"
                      @click="detailTabIndex = 6"
                    >
                      機台指示燈號
                    </button>
                  </div>
                </nav>
                <div
                  class="tab-content machStatus-tab-content pb-2"
                  id="nav-tabContent"
                >
                  <!-- 即時工單狀態 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 0,
                    }"
                    id="nav-instant"
                    role="tabpanel"
                    aria-labelledby="nav-instant-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 mt-3 text-start">
                        <template v-if="ht_work_code.length != 0">
                          <button
                            v-for="(item, key) in ht_work_code"
                            :key="key"
                            class="btn htWorkCode-btn"
                            :class="{ active: ht_button_select == key }"
                            @click="ht_button_select = key"
                          >
                            工單{{ key + 1 }}
                          </button>
                        </template>
                        <template v-else>
                          <button class="btn htWorkCode-btn">工單1</button>
                        </template>
                      </div>
                    </div>
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>工單資訊</span>
                        </div>
                        <commonTable
                          :fields="workCodeFields"
                          :items="workCodeItems"
                        />
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>生產資訊</span>
                        </div>
                        <commonTable
                          :fields="produceFields"
                          :items="produceItems"
                        >
                          <template #cell(qty)="data">
                            {{ data.value.name }}:
                            {{
                              isNaN(Number(data.value.count))
                                ? data.value.count
                                : Number(data.value.count).toLocaleString(
                                    "en-US"
                                  )
                            }}
                          </template>
                          <template #cell(unitWeight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(standardTotalWeight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(materialTotalWeight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                        <!-- 進度條 -->
                        <div class="mt-5">
                          <div
                            style="
                              margin: 15px 0px;
                              width: 100%;
                              text-align: center;
                              white-space: nowrap;
                            "
                          >
                            <div
                              ref="ht_in_text"
                              style="
                                display: inline-block;
                                width: 5rem;
                                vertical-align: middle;
                              "
                            >
                              輾牙重量:
                            </div>
                            <div
                              style="
                                display: inline-block;
                                width: calc(99% - 5rem);
                                vertical-align: middle;
                              "
                              class="position-relative"
                            >
                              <div
                                class="progress position-relative"
                                style="height: 45px"
                              >
                                <div
                                  v-if="percent_bar.work_code == ''"
                                  class="progress-bar"
                                  style="width: 0%; background-color: #000000"
                                ></div>
                                <div
                                  v-else-if="
                                    percent_bar.work_code != '' &&
                                    percent_bar.thd_percent != ''
                                  "
                                  :class="{
                                    'machStatus-progress-bar-R':
                                      machine_status == 'R',
                                    'machStatus-progress-bar-Q':
                                      machine_status == 'Q',
                                    'machStatus-progress-bar-H':
                                      machine_status == 'H',
                                    'machStatus-progress-bar-M':
                                      machine_status == 'M',
                                  }"
                                  :style="{
                                    width: percent_bar.thd_percent * 0.87 + '%',
                                  }"
                                  class="progress-bar"
                                ></div>

                                <span
                                  v-if="percent_bar.work_code == ''"
                                  class="elecboard-progress-bar-text mb-0"
                                ></span>
                                <span
                                  v-else-if="percent_bar.work_code != ''"
                                  class="elecboard-progress-bar-text mx-auto mb-0"
                                  style="
                                    line-height: 45px;
                                    font-size: 1.3rem;
                                    position: absolute;
                                    width: 100%;
                                  "
                                >
                                  {{
                                    percent_bar.af_thd_weight.toLocaleString(
                                      "en-US"
                                    ) +
                                    "/" +
                                    percent_bar.work_dispatch_weight.toLocaleString(
                                      "en-US"
                                    ) +
                                    " " +
                                    percent_bar.thd_percent +
                                    "%"
                                  }}
                                </span>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  height: 45px;
                                  position: absolute;
                                  left: 0;
                                  top: 0;
                                "
                              >
                                <div
                                  style="
                                    z-index: 10;
                                    position: absolute;
                                    width: 2px;
                                    height: 115%;
                                    background-color: #c10000;
                                    left: calc(90% * 0.87 - 1px);
                                    top: -15%;
                                  "
                                >
                                  <div
                                    style="
                                      z-index: 10;
                                      position: absolute;
                                      color: #c10000;
                                      width: 60px;
                                      left: calc(90% * 0.87 - 30px);
                                      top: calc(-10% - 22px);
                                      text-align: center;
                                    "
                                  >
                                    {{
                                      (
                                        percent_bar.work_dispatch_weight * 0.9
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                      })
                                    }}
                                  </div>
                                </div>
                                <div
                                  style="
                                    position: absolute;
                                    width: 2px;
                                    height: 115%;
                                    background-color: #474747;
                                    left: calc(100% * 0.87 - 1px);
                                    top: -15%;
                                  "
                                >
                                  <div
                                    style="
                                      z-index: 10;
                                      position: absolute;
                                      color: #474747;
                                      width: 60px;
                                      left: calc(100% * 0.87 - 30px);
                                      top: calc(-10% - 22px);
                                      text-align: center;
                                    "
                                  >
                                    {{
                                      percent_bar.work_dispatch_weight.toLocaleString(
                                        "en-US",
                                        {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        }
                                      )
                                    }}
                                  </div>
                                </div>
                                <div
                                  style="
                                    position: absolute;
                                    width: 2px;
                                    height: 115%;
                                    background-color: #c10000;
                                    left: calc(110% * 0.87 - 1px);
                                    top: -15%;
                                  "
                                >
                                  <div
                                    style="
                                      z-index: 10;
                                      position: absolute;
                                      color: #c10000;
                                      width: 60px;
                                      left: calc(110% * 0.87 - 30px);
                                      top: calc(-10% - 22px);
                                      text-align: center;
                                    "
                                  >
                                    {{
                                      (
                                        percent_bar.work_dispatch_weight * 1.1
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                      })
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style="
                              margin: 15px 0px;
                              width: 100%;
                              text-align: center;
                              white-space: nowrap;
                            "
                          >
                            <div
                              style="
                                display: inline-block;
                                width: 5rem;
                                vertical-align: middle;
                              "
                            >
                              入料進度:
                            </div>
                            <div
                              style="
                                display: inline-block;
                                width: calc(99% - 5rem);
                                vertical-align: middle;
                              "
                              class="position-relative"
                            >
                              <div
                                class="progress position-relative"
                                style="height: 45px"
                              >
                                <div
                                  v-if="percent_bar.work_code == ''"
                                  class="progress-bar"
                                  style="width: 0%; background-color: #000000"
                                ></div>
                                <div
                                  v-else-if="
                                    percent_bar.work_code != '' &&
                                    percent_bar.work_percent != ''
                                  "
                                  :class="{
                                    'machStatus-progress-bar-R':
                                      machine_status == 'R',
                                    'machStatus-progress-bar-Q':
                                      machine_status == 'Q',
                                    'machStatus-progress-bar-H':
                                      machine_status == 'H',
                                    'machStatus-progress-bar-M':
                                      machine_status == 'M',
                                  }"
                                  :style="{
                                    width:
                                      percent_bar.work_percent * 0.87 + '%',
                                  }"
                                  class="progress-bar"
                                ></div>
                                <span
                                  v-if="percent_bar.work_code == ''"
                                  class="elecboard-progress-bar-text mb-0"
                                ></span>
                                <span
                                  v-else-if="percent_bar.work_code != ''"
                                  class="elecboard-progress-bar-text mx-auto mb-0"
                                  style="
                                    line-height: 45px;
                                    font-size: 1.3rem;
                                    position: absolute;
                                    width: 100%;
                                  "
                                >
                                  {{
                                    percent_bar.device_count.toLocaleString(
                                      "en-US"
                                    ) +
                                    "/" +
                                    percent_bar.work_qty.toLocaleString(
                                      "en-US"
                                    ) +
                                    " "
                                  }}
                                  {{ percent_bar.work_percent + "%" }}
                                </span>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  height: 45px;
                                  position: absolute;
                                  left: 0;
                                  top: 0;
                                "
                              >
                                <div
                                  style="
                                    z-index: 10;
                                    position: absolute;
                                    width: 2px;
                                    height: 100%;
                                    background-color: #c10000;
                                    left: calc(90% * 0.87 - 1px);
                                  "
                                ></div>
                                <div
                                  style="
                                    position: absolute;
                                    width: 2px;
                                    height: 100%;
                                    background-color: #474747;
                                    left: calc(100% * 0.87 - 1px);
                                  "
                                ></div>
                                <div
                                  style="
                                    position: absolute;
                                    width: 2px;
                                    height: 100%;
                                    background-color: #c10000;
                                    left: calc(110% * 0.87 - 1px);
                                  "
                                ></div>
                              </div>
                            </div>
                          </div>
                          <div
                            style="
                              margin: 15px 0px;
                              width: 100%;
                              text-align: center;
                              white-space: nowrap;
                            "
                          >
                            <div
                              ref="ht_in_text"
                              style="
                                display: inline-block;
                                width: 5rem;
                                vertical-align: middle;
                              "
                            >
                              出料進度:
                            </div>
                            <div
                              style="
                                display: inline-block;
                                width: calc(99% - 5rem);
                                vertical-align: middle;
                              "
                              class="position-relative"
                            >
                              <div
                                class="progress position-relative"
                                style="height: 45px"
                              >
                                <div
                                  v-if="percent_bar.work_code == ''"
                                  class="progress-bar"
                                  style="width: 0%; background-color: #000000"
                                ></div>
                                <div
                                  v-else-if="
                                    percent_bar.work_code != '' &&
                                    percent_bar.work_out_percent != ''
                                  "
                                  :class="{
                                    'machStatus-progress-bar-R':
                                      machine_status == 'R',
                                    'machStatus-progress-bar-Q':
                                      machine_status == 'Q',
                                    'machStatus-progress-bar-H':
                                      machine_status == 'H',
                                    'machStatus-progress-bar-M':
                                      machine_status == 'M',
                                  }"
                                  :style="{
                                    width:
                                      percent_bar.work_out_percent * 0.87 + '%',
                                  }"
                                  class="progress-bar"
                                ></div>
                                <span
                                  v-if="percent_bar.work_code == ''"
                                  class="elecboard-progress-bar-text mb-0"
                                ></span>
                                <span
                                  v-else-if="percent_bar.work_code != ''"
                                  class="elecboard-progress-bar-text mx-auto mb-0"
                                  style="
                                    line-height: 45px;
                                    font-size: 1.3rem;
                                    position: absolute;
                                    width: 100%;
                                  "
                                >
                                  {{
                                    percent_bar.device_out_count.toLocaleString(
                                      "en-US"
                                    ) +
                                    "/" +
                                    percent_bar.work_qty.toLocaleString(
                                      "en-US"
                                    ) +
                                    " "
                                  }}
                                  {{ percent_bar.work_out_percent + "%" }}
                                </span>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  height: 45px;
                                  position: absolute;
                                  left: 0;
                                  top: 0;
                                "
                              >
                                <div
                                  style="
                                    z-index: 10;
                                    position: absolute;
                                    width: 2px;
                                    height: 100%;
                                    background-color: #c10000;
                                    left: calc(90% * 0.87 - 1px);
                                  "
                                ></div>
                                <div
                                  style="
                                    position: absolute;
                                    width: 2px;
                                    height: 100%;
                                    background-color: #474747;
                                    left: calc(100% * 0.87 - 1px);
                                  "
                                ></div>
                                <div
                                  style="
                                    position: absolute;
                                    width: 2px;
                                    height: 100%;
                                    background-color: #c10000;
                                    left: calc(110% * 0.87 - 1px);
                                  "
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>每桶產出</span>
                        </div>
                        <commonTable
                          :fields="bucketFields"
                          :items="bucketItems"
                          stickyHeader="186px"
                        >
                          <template #cell(screwWeight)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>總生產時間</span>
                        </div>
                        <commonTable
                          :fields="produceTimeFields"
                          :items="produceTimeItems"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 機台影像 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 2,
                    }"
                    id="nav-camera"
                    role="tabpanel"
                    aria-labelledby="nav-camera-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph text-start mt-3">
                        <machineCamera :machineCameraData="machineCameraData" />
                      </div>
                    </div>
                  </div>
                  <!-- 運轉日誌 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 3,
                    }"
                    id="nav-operate"
                    role="tabpanel"
                    aria-labelledby="nav-operate-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="text-end" style="margin-bottom: 0.6rem">
                          <exportCsv
                            :exportData="operateLogItems"
                            :exportDataTitle="
                              operateLogFields.map((item) => item.label)
                            "
                            :exportFileName="
                              '運轉日誌_' +
                              deviceName +
                              '_' +
                              new Date().getFullYear() +
                              ('0' + (new Date().getMonth() + 1)).slice(-2) +
                              ('0' + new Date().getDate()).slice(-2)
                            "
                          />
                        </div>
                        <commonTable
                          :fields="operateLogFields"
                          :items="operateLogItems"
                          :tableStyle="{ 'white-space': 'pre-line' }"
                          stickyHeader="230px"
                        >
                          <template #cell(status)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(alarmCode)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(alarmDetail)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(startTime)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(endTime)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                          <template #cell(durationTime)="data">
                            <template
                              v-if="
                                data.item.alarmCode != '' &&
                                data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
                                data.item.status == '警報'
                              "
                            >
                              <b style="color: red">{{ data.value }}</b>
                            </template>
                            <template v-else>
                              {{ data.value }}
                            </template>
                          </template>
                        </commonTable>
                      </div>
                    </div>
                  </div>
                  <!-- 當日完成工單 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 4,
                    }"
                    id="nav-complete"
                    role="tabpanel"
                    aria-labelledby="nav-complete-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <template v-if="!completeWorkdetail">
                          <commonTable
                            :fields="completeWorkFields"
                            :items="completeWorkItems"
                            :rowClick="completeWorkRowClick"
                            stickyHeader="465px"
                          >
                            <template #cell(qty)="data">{{
                              isNaN(Number(data.value))
                                ? data.value
                                : Number(data.value).toLocaleString("en-US")
                            }}</template>
                            <template #cell(completeQty)="data">{{
                              isNaN(Number(data.value))
                                ? data.value
                                : Number(data.value).toLocaleString("en-US")
                            }}</template>
                            <template #cell(weight)="data">{{
                              isNaN(Number(data.value))
                                ? data.value
                                : Number(data.value).toLocaleString("en-US")
                            }}</template>
                            <template #cell(completeWeight)="data">{{
                              isNaN(Number(data.value))
                                ? data.value
                                : Number(data.value).toLocaleString("en-US")
                            }}</template>
                          </commonTable>
                        </template>
                        <template v-else>
                          <div class="col-12 mb-2 px-0 text-end">
                            <button
                              class="machStatus-button"
                              @click="completeWorkdetail = false"
                            >
                              返回
                            </button>
                          </div>
                          <workOrderHistoryList></workOrderHistoryList>
                        </template>
                      </div>
                    </div>
                  </div>
                  <!-- 警報履歷 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 5,
                    }"
                    id="nav-alarm"
                    role="tabpanel"
                    aria-labelledby="nav-alarm-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="text-end" style="margin-bottom: 0.6rem">
                          <exportCsv
                            :exportData="alarmHistoryItems"
                            :exportDataTitle="
                              alarmHistoryFields.map((item) => item.label)
                            "
                            :exportFileName="
                              '警報履歷_' +
                              deviceName +
                              '_' +
                              new Date().getFullYear() +
                              ('0' + (new Date().getMonth() + 1)).slice(-2) +
                              ('0' + new Date().getDate()).slice(-2)
                            "
                          />
                        </div>
                        <commonTable
                          :fields="alarmHistoryFields"
                          :items="alarmHistoryItems"
                          :tableStyle="{ 'white-space': 'pre-line' }"
                          stickyHeader="230px"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 機台指示燈號 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 6,
                    }"
                    id="nav-light"
                    role="tabpanel"
                    aria-labelledby="nav-light-tab"
                  >
                    <div class="text-left col-12">
                      <div class="row justify-content-start mx-0 p-3">
                        <div
                          v-for="(item, key) in machineLightData"
                          class="mt-2 ml-0 justify-content-center col-sm-6 col-md-4 col-lg-3 col-xl-2 col-6"
                        >
                          <light :name="item.name" :color="item.color" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1 px-0"></div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, inject, provide, ref, watch } from "@vue/runtime-core";
import stackBar from "@/components/stackBar.vue";
import commonTable from "@/components/commonTable.vue";
import machineCamera from "@/components/machineCamera.vue";
import exportCsv from "@/components/exportCsv.vue";
import workOrderHistoryList from "@/components/workOrderHistoryList.vue";
import inspectionList from "@/components/inspectionList.vue";
import light from "@/components/light.vue";
export default {
  components: {
    stackBar,
    commonTable,
    machineCamera,
    exportCsv,
    workOrderHistoryList,
    inspectionList,
    light,
  },
  setup() {
    const siteName = inject("siteName");
    const oper = inject("oper");
    const operName = inject("operName");
    const deviceName = inject("deviceName");
    const detail = inject("detail");
    const machStatusData = inject("machStatusData");
    const nowTime = inject("nowTime");
    const detailTabIndex = inject("detailTabIndex");
    const commonMethods = inject("commonMethods");

    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const stacksBarClass = computed(
      () => store.getters["stackBar/get_stacksBarClass"]
    );
    const stacksBarMaxValue = computed(
      () => store.getters["stackBar/get_stacksBarMaxValue"]
    );
    const stacksBarDefault = computed(
      () => store.getters["stackBar/get_stacksBarDefault"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const machineImage = require("@/assets/heat-treatment-model.jpg");
    const machine_status = ref("R");
    const deviceRunTime = ref("-");
    const deviceQueueTime = ref("-");
    const deviceActivation = ref("-");
    const deviceModel = ref("-");
    const deviceDayWeight = ref("-");
    const htInStackInformation = ref(stacksBarDefault.value);
    const htOutStackInformation = ref(stacksBarDefault.value);
    const ht_button_select = ref(0);
    const ht_work_code = ref([]);
    console.log(siteName.value, operName.value, deviceName.value, detail.value);

    //工單資訊
    const workCodeFields = [
      {
        key: "workOrgCode",
        label: "工單編號",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "productCode",
        label: "料號",
        thStyle: {
          "min-width": "220px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "workControlCard",
        label: "管制卡號",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "productChineseName",
        label: "料名",
        thStyle: {
          "min-width": "380px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const workCodeItems = ref([]);

    //生產資訊
    const produceFields = [
      {
        key: "itemTitle",
        label: ["項目", "狀態"],
        segmentation: {
          sup: {},
          sub: {},
        },
        thStyle: {
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "workDispatchWeight",
        label: "工單重量(KG)",
        thStyle: {
          "min-width": "130px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "workTotalWeight",
        label: "輾牙完工重量(KG)",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "workInWeight",
        label: "熱處理入料重量(KG)",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "quenchFurnTime",
        label: "淬火入料時間",
        thStyle: {
          "min-width": "320px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "temperingFurnTime",
        label: "回火入料時間",
        thStyle: {
          "min-width": "320px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const produceItems = ref([]);
    const percent_bar = ref({
      work_code: "",
      device_count: 0,
      work_qty: 0,
      work_percent: 0,
      device_out_count: 0,
      work_out_percent: 0,
      thd_percent: 0,
      af_thd_weight: 0,
      work_dispatch_weight: 0,
    });

    //每桶產出
    const bucketFields = [
      {
        key: "code",
        label: "流程卡號",

        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "furnaceCode",
        label: "爐號",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "screwWeight",
        label: "重量(KG)",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const bucketItems = ref([]);

    //總生產時間
    const produceTimeFields = [
      {
        key: "code",
        label: "製程",

        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "device_name",
        label: "機台編號",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalTime",
        label: "生產時間",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const produceTimeItems = ref([]);

    //機台影像
    const machineCameraData = ref([]);

    //運轉日誌資訊
    const operateLogFields = [
      {
        key: "status",
        label: "狀態",
        thStyle: {
          "min-width": "85px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmCode",
        label: "代碼",
        thStyle: {
          "min-width": "130px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmDetail",
        label: "代碼說明",
        thStyle: {
          "min-width": "210px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "durationTime",
        label: "持續時間",
        thStyle: {
          "min-width": "115px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const operateLogItems = ref([]);

    //當日完成工單資訊
    const completeWorkFields = [
      {
        key: "workOrgCode",
        label: "工單單號",
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "itemName",
        label: "產品品名",
        thStyle: {
          "min-width": "280px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "qty",
        label: "派工數量(PCS)",
        thStyle: {
          "min-width": "140px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "completeQty",
        label: "完工數量(PCS)",
        thStyle: {
          "min-width": "140px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "weight",
        label: "派工重量(KG)",
        thStyle: {
          "min-width": "130px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "completeWeight",
        label: "完工重量(KG)",
        thStyle: {
          "min-width": "130px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "170px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "完成時間",
        thStyle: {
          "min-width": "170px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const completeWorkItems = ref([]);
    const workID = ref();
    const completeWorkdetail = ref(false);
    const completeWorkRowClick = (itemData) => {
      console.log(itemData.workOrgCode);
      workID.value = itemData.workOrgCode;
      completeWorkdetail.value = true;
    };
    provide("wip_lot", workID);

    //警報履歷資訊
    const alarmHistoryFields = [
      {
        key: "alarmCode",
        label: "警報代碼",
        thStyle: {
          "min-width": "125px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmDetail",
        label: "警報代碼說明",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmVideo",
        label: "機台影像",
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "durationTime",
        label: "持續時間",
        thStyle: {
          "min-width": "115px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const alarmHistoryItems = ref([]);

    //機台燈號
    const machineLightData = ref({});

    const updateData = () => {
      if (machStatusData.value != null) {
        machine_status.value = machStatusData.value.machine_status;
        deviceRunTime.value = machStatusData.value.deviceRunTime;
        deviceQueueTime.value = machStatusData.value.deviceQueueTime;
        deviceActivation.value = machStatusData.value.deviceActivation;
        htInStackInformation.value =
          machStatusData.value.ht_in_stack_information;
        htOutStackInformation.value =
          machStatusData.value.ht_out_stack_information;
        // percent_bar.value = machStatusData.value.percent_bar;
        deviceModel.value = machStatusData.value.device_model;
        deviceDayWeight.value = machStatusData.value.device_day_weight;

        ht_work_code.value = machStatusData.value.on_line_work;
        showHtWorkCode();
        // produceItems.value = machStatusData.value.produce_information;
        // bucketItems.value = machStatusData.value.bucket_information;
        // produceTimeItems.value =
        //   machStatusData.value.total_produce_time_information;

        operateLogItems.value = machStatusData.value.operateLogItems;
        alarmHistoryItems.value = machStatusData.value.alarmHistoryItems;
        machineLightData.value = machStatusData.value.machine_light_value;
      }
    };

    const showHtWorkCode = () => {
      if (ht_work_code.value[ht_button_select.value] == undefined) {
        workCodeItems.value = [];
        produceItems.value = [];
        bucketItems.value = [];
        produceTimeItems.value = [];
        percent_bar.value = {
          work_code: "",
          device_count: 0,
          work_qty: 0,
          work_percent: 0,
          device_out_count: 0,
          work_out_percent: 0,
          thd_percent: 0,
          af_thd_weight: 0,
          work_dispatch_weight: 0,
        };
        return;
      }
      let ht_data = ht_work_code.value[ht_button_select.value];
      workCodeItems.value = ht_data.work_code_information;
      produceItems.value = ht_data.produce_information;
      bucketItems.value = ht_data.bucket_information;
      produceTimeItems.value = ht_data.total_produce_time_information;

      if (workCodeItems.value.length > 0) {
        percent_bar.value.work_code = workCodeItems.value[0].workOrgCode;
      } else {
        percent_bar.value.work_code = "";
      }
      if (produceItems.value.length > 0) {
        percent_bar.value.device_count = produceItems.value[0].workHtInWeight;
        percent_bar.value.device_out_count =
          produceItems.value[0].workOutWeight;
        percent_bar.value.work_qty = produceItems.value[0].workInWeight;
        percent_bar.value.work_dispatch_weight =
          produceItems.value[0].workDispatchWeight;
        percent_bar.value.af_thd_weight = produceItems.value[0].workTotalWeight;

        if (
          percent_bar.value.work_dispatch_weight == "-" ||
          percent_bar.value.af_thd_weight == "-"
        ) {
          percent_bar.value.thd_percent = "100.00";
        } else {
          percent_bar.value.thd_percent = (
            (percent_bar.value.af_thd_weight /
              percent_bar.value.work_dispatch_weight) *
            100
          ).toFixed(2);
        }

        if (percent_bar.value.work_qty == "-") {
          if (percent_bar.value.device_count <= 0) {
            percent_bar.value.work_percent = 0;
          } else {
            percent_bar.value.work_percent = 100;
          }
          if (percent_bar.value.device_out_count <= 0) {
            percent_bar.value.work_out_percent = 0;
          } else {
            percent_bar.value.work_out_percent = 100;
          }
        } else {
          let this_percent = (
            (percent_bar.value.device_count /
              percent_bar.value.work_dispatch_weight) *
            100
          ).toFixed(2);
          percent_bar.value.work_percent = this_percent;

          let this_out_percent = (
            (percent_bar.value.device_out_count /
              percent_bar.value.work_dispatch_weight) *
            100
          ).toFixed(2);
          percent_bar.value.work_out_percent = this_out_percent;
        }
      }
    };

    const queryMachineCamera = () => {
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "machstatus";
      params["oper"] = operName.value;
      params["device_name"] = deviceName.value;
      params["methods"] = "POST";
      params["whichFunction"] = "QueryMachineCamera";
      console.log(params);
      methods.axiosAction(params).then(() => {
        var result = axiosResult.value;
        console.log(result);
        if (result["Response"] == "ok") {
          machineCameraData.value = result["QueryTableData"];
        } else {
          machineCameraData.value = [];
          console.log("erro machineCameraData" + result["QueryTableData"]);
        }
      });
    };

    const queryWorkorderHistory = () => {
      let endTime = new Date();
      let startTime = new Date(endTime.getTime() - 172800000);
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "machstatus";
      params["methods"] = "POST";
      params["whichFunction"] = "WorkorderHistory";
      params["startTime"] = `${startTime.getFullYear()}-${
        startTime.getMonth() + 1
      }-${startTime.getDate()} ${startTime.getHours()}:${startTime.getMinutes()}:${startTime.getSeconds()}`;
      params["endTime"] = `${endTime.getFullYear()}-${
        endTime.getMonth() + 1
      }-${endTime.getDate()} ${endTime.getHours()}:${endTime.getMinutes()}:${endTime.getSeconds()}`;
      params["deviceID"] = deviceName.value;
      params["siteName"] = siteName.value;
      params["oper"] = oper.value;

      methods.axiosAction(params).then(() => {
        var result = axiosResult.value;
        console.log(result);
        if (result["Response"] == "ok") {
          let result_Data = result["QueryTableData"];

          let workOrderHistoryArray = [];

          for (let i = 0; i < result_Data.length; i++) {
            let workOrderHistoryObj = {};
            workOrderHistoryObj["workOrgCode"] =
              result_Data[i]["work_org_code"];
            workOrderHistoryObj["itemName"] = result_Data[i]["itemName"];
            workOrderHistoryObj["qty"] = result_Data[i]["qty"];
            workOrderHistoryObj["completeQty"] = result_Data[i]["completeQty"];
            workOrderHistoryObj["weight"] = result_Data[i]["weight"];
            workOrderHistoryObj["completeWeight"] =
              result_Data[i]["completeWeight"];
            workOrderHistoryObj["startTime"] = result_Data[i]["startTime"];
            workOrderHistoryObj["endTime"] = result_Data[i]["endTime"];
            workOrderHistoryArray.push(workOrderHistoryObj);
          }
          completeWorkItems.value = workOrderHistoryArray;
        } else if (result["Response"] == "no data") {
          completeWorkItems.value = [];
          methods.setTimeoutAlert("查無資料");
        } else {
          completeWorkItems.value = [];
          methods.setTimeoutAlert(result["Response"]);
        }
        methods.triggerLoadingBar();
      });
    };

    watch(
      machStatusData,
      () => {
        updateData();
      },
      { deep: true }
    );

    watch(detailTabIndex, (newValue) => {
      switch (newValue) {
        case 2:
          queryMachineCamera();
          break;
        case 4:
          methods.triggerLoadingBar();
          queryWorkorderHistory();
          break;

        default:
          break;
      }
    });

    watch(ht_button_select, (newValue) => {
      showHtWorkCode();
    });

    return {
      siteName,
      operName,
      deviceName,
      detail,
      machineImage,
      nowTime,
      deviceRunTime,
      deviceQueueTime,
      deviceActivation,
      deviceModel,
      deviceDayWeight,
      machine_status,
      stacksBarClass,
      stacksBarMaxValue,
      htInStackInformation,
      htOutStackInformation,
      detailTabIndex,
      ht_button_select,
      ht_work_code,
      workCodeFields,
      workCodeItems,
      produceFields,
      produceItems,
      percent_bar,
      bucketFields,
      bucketItems,
      produceTimeFields,
      produceTimeItems,

      machineCameraData,
      operateLogFields,
      operateLogItems,
      completeWorkFields,
      completeWorkItems,
      completeWorkdetail,
      completeWorkRowClick,
      alarmHistoryFields,
      alarmHistoryItems,
      machineLightData,
    };
  },
};
</script>

<style scoped>
.stackBarTitle {
  width: 7rem;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}
.stackBarContent {
  width: calc(100% - 7rem);
  display: inline-block;
  vertical-align: middle;
}
.htWorkCode-btn {
  height: 2rem;
  padding: 0;
  width: 4.25rem;
  color: var(--main-font-color);
  background-color: var(--main-status-secondary-color);
  border-color: var(--main-status-secondary-color);
  margin: 0.25rem 0.125rem;
}
.htWorkCode-btn:hover {
  color: var(--main-font-color);
}
.htWorkCode-btn.active {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}
</style>
